import React from 'react';
export function ExpertSection() {
  return <section className="w-full bg-bg-dark py-20 px-4" data-id="element-69">
      <div className="max-w-3xl mx-auto text-center" data-id="element-70">
        <div className="text-4xl sm:text-5xl mb-6" data-id="element-71">🧮</div>

        <h2 className="text-3xl sm:text-4xl font-serif font-black text-text-main mb-6" data-id="element-72">
          Sobre ProfePack
        </h2>

        <p className="text-text-sec text-lg sm:text-xl leading-relaxed font-medium max-w-2xl mx-auto" data-id="element-73">
          Nacimos con una misión clara: devolverle el tiempo y la paz mental a
          los docentes de todo el mundo hispanohablante. Sabemos lo que es
          quedarse despierto hasta las 2 AM preparando una clase. Matemática
          Lista es el sistema que nos hubiera gustado tener cuando empezamos.
        </p>
      </div>
    </section>;
}